import { useEffect, useRef } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';

import classes from './ScrollBlock.scss';

export function useScrollBlock(blocked?: boolean) {
  const { isSSR } = useEnvironment();

  const eligible = useRef(false);

  useEffect(() => {
    if (isSSR) {
      return;
    }

    blocked ? lock() : unlock();

    return () => unlock();
  }, [isSSR, blocked]);

  function lock() {
    const isLocked = document.body.classList.contains(classes.lock);

    eligible.current = !isLocked;

    if (!isLocked) {
      document.body.classList.add(classes.lock);
    }
  }

  function unlock() {
    if (eligible.current) {
      document.body.classList.remove(classes.lock);
    }
  }
}
